/**
 * Унифицированный логер ошибок сокетов.
 *
 * @param {Object} options
 * @param {string} options.eventName - Название события socket.io.
 * @param {Object} [options.payload] - Полный payload, пришедший от сервера.
 * @param {string} [options.source] - Доп. описание источника (например, имя слушателя).
 * @param {string} [options.location] - Файл, в котором сработала обработка.
 */
export const logSocketError = ({ eventName, payload, source, location }) => {
  console.error('[socket][error]', {
    event: eventName,
    reason: payload?.reason || 'Unknown reason',
    payload,
    source,
    location,
  });
};
